module.exports = __webpack_public_path__ + "media/images/restaurant/areas/shikoku-243712f3c5b9122d02dc3f701d2c52ae.png";